var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SiteNav'),_c('main',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1),_c('SiteFooter'),_c('button',{staticClass:"to-top",class:{ 'is-show': _vm.showTop },attrs:{"aria-label":"回到顶部"},on:{"click":_vm.toTop}},[_c('IconSvg',{attrs:{"name":"arrow-up"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }